module.exports = __webpack_public_path__ + "static/media/logo.3d7f26e7.svg";